// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"483":"4def0ee8e5","938":"f31afb2cd6"}[chunkId] + ".js";
};